module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing-codeOfConduct"
  }, [_c('section', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), (_vm.terms.length) ? _c('div', {
    staticClass: "container block-text",
    domProps: {
      "innerHTML": _vm._s(_vm.terms)
    }
  }) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center headline-container"
  }, [_c('h1', {
    staticClass: "headline"
  }, [_vm._v("Supplier Code of Conduct")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e8ad394","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/CodeOfConduct.vue
// module id = 1501
// module chunks = 0